import React from "react";
import styled from "styled-components";
//
import Image from "./image";
import { RichText } from "components/prismic";
//

export default ({
  articles,
  title,
  text,
  images_xl,
  images_l,
  images_m,
  images_s,
  images_bottom,
  ...rest
}) => (
  <Wrap>
    <Text>
      <RichText {...text} />
    </Text>

    <Medium>
      {images_m.map((image, i) => (
        <Image key={i} {...image} />
      ))}
    </Medium>

    <XLarge>
      <List>
        {images_xl.map((image, i) => (
          <Image key={i} {...image} />
        ))}
      </List>
    </XLarge>

    <LargeAndSmall>
      <List>
        {images_l.map((image, i) => (
          <Image key={i} {...image} />
        ))}
      </List>
      <List>
        {images_s.map((image, i) => (
          <Image key={i} {...image} />
        ))}
      </List>
    </LargeAndSmall>

    <XLarge>
      {images_bottom.map((image, i) => (
        <Image key={i} {...image} />
      ))}
    </XLarge>

    {/* <pre>
      <code>{JSON.stringify(rest, null, 2)}</code>
    </pre> */}
  </Wrap>
);
//
const Wrap = styled.div`
  display: grid;
  // grid-gap: 0.25rem;
  // justify-content: center;
`;
const LargeAndSmall = styled.div`
  display: grid;
  grid-gap: 0.5rem;
  @media (min-width: 768px) {
    grid-template-columns: 2fr 1fr;
  }
`;
const XLarge = styled.div`
  display: grid;
  justify-items: center;
`;
const Medium = styled.div`
  display: grid;
  grid-gap: 0.5rem;
  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const List = styled.div``;
const Text = styled.div`
  p {
    text-justify: inter-word;
    max-width: 900px;
    padding: 0 1rem;
  }
`;
